/* PagingHistoryFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

class PagingHistoryFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedExecutionsFeed({}, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _feedReestablish() {
        return this._feed.reestablishFeed(this._userSession.activeOrganization.id, {}, this._entityFields, this._sort);
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._relatedEntityDef.loadConfigAuditExecutionIdsForSelection(tenantId, selection);
    }
}

module.exports = PagingHistoryFeed;
